/* jshint esversion: 6 */

const LocalSession = {
  lookup: (sessionKey) => {
    let sessionData;
    try {
      sessionData = JSON.parse(localStorage.getItem(sessionKey));
    } catch(err) {
      sessionData = {};
    }
    return sessionData;
  },
  save: (key, data) => {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (err) {}
  },
  reset: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (err) {}
  }
};
export default LocalSession;
